import { html, LitElement } from 'lit';
import { OffersService } from '../offers.service.js';
import { style } from './iconic-offer-header.style.js';
import '@cof/fs-label-badge-wc/fs-label-badge.js';

const termComparisonHeaders = {
  DEFAULT: {
    LONGER_TERM: 'Extend loan term',
    LONGEST_TERM: 'Longest loan term',
    SAME_TERM: 'Same loan term',
    SHORTER_TERM: 'Shorten loan term',
    SHORTEST_TERM: 'Shortest loan term',
  },
};
Object.freeze(termComparisonHeaders);

class IconicRefiOfferHeader extends LitElement {
  constructor() {
    super();
    this.hasSavings = OffersService.hasSavings;
    this.hasStips = OffersService.hasStips;
    this.isGoalHeader = this.hasSavings && !this.hasStips;
  }

  static properties = {
    offerApr: { type: String, attribute: 'offer-apr' },
    currentApr: { type: String, attribute: 'current-apr' },
    offerTerm: { type: String, attribute: 'offer-term' },
    currentTerm: { type: String, attribute: 'current-term' },
  };

  static get styles() {
    return [style];
  }

  render() {
    return html`<fs-label-badge id="pill" emphasis="medium" variant="positive">${this.termComparisonHeader()}</fs-label-badge>`;
  }

  termComparisonHeader() {
    const termKey = `${this.offer.meta.term}_TERM`;
    return termComparisonHeaders.DEFAULT[termKey];
  }
}

customElements.define('refi-iconic-offer-header', IconicRefiOfferHeader);
